var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "baseSelectBox",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "baseSelectBox__container" },
        [
          _c(
            "div",
            { staticClass: "baseSelectBox__containerInput" },
            [
              _vm._t("input-before"),
              _vm._v(" "),
              _vm._l(_vm.chipList, function (item) {
                return _vm.isMultiSelect && !_vm.displayAsChip
                  ? _c("span", { staticClass: "baseSelectBox__chips" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.label) +
                          "\n                "
                      ),
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.isMultiSelect && _vm.displayAsChip
                ? _c(_vm.chipsComponent, {
                    tag: "component",
                    staticClass: "baseSelectBox__chips",
                    model: {
                      value: _vm.chipList,
                      callback: function ($$v) {
                        _vm.chipList = $$v
                      },
                      expression: "chipList",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(_vm.inputFieldComponent, {
                ref: "selectBoxInput",
                tag: "component",
                staticClass: "baseSelectBox__input",
                attrs: {
                  placeholder: _vm.searchFieldPlaceholder,
                  "clear-icon": false,
                },
                on: { focus: _vm.onInputFocus, blur: _vm.onInputBlur },
                nativeOn: {
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.onEnterKeyDown.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      ) {
                        return null
                      }
                      return _vm.onUpDownKeyDown(true)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      ) {
                        return null
                      }
                      return _vm.onUpDownKeyDown.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                          "Backspace",
                          "Delete",
                          "Del",
                        ])
                      ) {
                        return null
                      }
                      return _vm.onDeleteKeyDown.apply(null, arguments)
                    },
                  ],
                },
                model: {
                  value: _vm.searchValueOrPlaceholder,
                  callback: function ($$v) {
                    _vm.searchValueOrPlaceholder = $$v
                  },
                  expression: "searchValueOrPlaceholder",
                },
              }),
              _vm._v(" "),
              _vm._t("input-end"),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "baseSelectBox__error" },
            [
              _vm._t("error", function () {
                return [_vm._v(_vm._s(_vm.error))]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMenuShown,
                    expression: "isMenuShown",
                  },
                ],
                ref: "selectBoxMenu",
                staticClass: "baseSelectBox__menu",
                class: _vm.menuClasses,
                style: _vm.menuStyles,
              },
              [
                _vm._t("before-items-fixed"),
                _vm._v(" "),
                _vm._t("before-items"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "baseSelectBox__menuInner",
                    attrs: { tabindex: "0" },
                    on: { focusout: _vm.onInputBlur },
                  },
                  [
                    _vm.isMultiSelect
                      ? _c(_vm.checkboxComponent, {
                          ref: "checkboxList",
                          tag: "component",
                          staticClass:
                            "baseSelectBox__item baseSelectBox__item--checkbox",
                          attrs: {
                            value: _vm.preparedValue,
                            items: _vm.filteredItems,
                          },
                          on: { input: _vm.onMultiSelectCheckboxInput },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.showMenu.apply(null, arguments)
                            },
                          },
                        })
                      : _vm._l(_vm.filteredItems, function (item) {
                          return _c(
                            "span",
                            {
                              staticClass: "baseSelectBox__item",
                              class: _vm.singleSelectItemClasses(item),
                              on: {
                                click: function ($event) {
                                  return _vm.onSingleSelectItemClick(item)
                                },
                              },
                            },
                            [
                              _vm._t(
                                "single-select-item-label",
                                function () {
                                  return [
                                    _vm._v(
                                      "\n\t\t\t\t\t            " +
                                        _vm._s(item.label) +
                                        "\n                            "
                                    ),
                                  ]
                                },
                                { item: item }
                              ),
                            ],
                            2
                          )
                        }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-items"),
                _vm._v(" "),
                _vm._t("after-items-fixed"),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }